import useSnackbarService from './useSnackbarService';

export default useSnackbarService;
